import React from 'react'

const RevenueChart = () => {
    return (
        <div>RevenueChart</div>
    )
}

export default RevenueChart